<template>
  <span><slot /></span>
</template>

<script>
export default {
  name: 'QuestionnaireButton'
}
</script>

<style scoped lang="scss">
  span {
    display: inline-block;
    cursor: pointer;
    border: 2px solid #008d76;
    color: #008d76;
    font-size: 1.1em;
    padding: .5em 1em;
    margin: 0.3em 0;
  }
</style>



// WEBPACK FOOTER //
// src/Questionnaire/QuestionnaireButton.vue